import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import RootLayout from './components/RootLayout';
import Home from './pages/Home';
import Bookmarks from './pages/Bookmarks';
import Trending from './pages/Trending';
import Notifications from './pages/Notifications';
import Auth from './pages/Auth';
import PostView from './pages/PostView';
import ErrorBoundary from './components/ErrorBoundary'; // Ensure this line remains
import { useFirebase } from './contexts/FirebaseContext';

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const { currentUser, loading } = useFirebase();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-purple-500 border-t-transparent"></div>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/auth" replace />;
  }

  return <>{children}</>;
};

const AuthRoute = ({ children }: { children: React.ReactNode }) => {
  const { currentUser, loading } = useFirebase();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-purple-500 border-t-transparent"></div>
      </div>
    );
  }

  if (currentUser) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <Navigate to="/home" replace />
      },
      {
        path: 'auth',
        element: <AuthRoute><Auth /></AuthRoute>,
        errorElement: <ErrorBoundary />
      },
      {
        path: 'home',
        element: <PrivateRoute><Home /></PrivateRoute>,
        errorElement: <ErrorBoundary />
      },
      {
        path: 'bookmarks',
        element: <PrivateRoute><Bookmarks /></PrivateRoute>,
        errorElement: <ErrorBoundary />
      },
      {
        path: 'trending',
        element: <PrivateRoute><Trending /></PrivateRoute>,
        errorElement: <ErrorBoundary />
      },
      {
        path: 'notifications',
        element: <PrivateRoute><Notifications /></PrivateRoute>,
        errorElement: <ErrorBoundary />
      },
      {
        path: 'post/:postId',
        element: <PrivateRoute><PostView /></PrivateRoute>,
        errorElement: <ErrorBoundary />
      },
      {
        path: '*',
        element: <ErrorBoundary />
      }
    ]
  }
]);
